module.exports = __webpack_public_path__ + "img/home_jp.489ec1d.jpg";